// RT-18: Disposable email domain blocklist.
// Prevents free-trial abuse via throwaway addresses.

const DISPOSABLE_DOMAINS = new Set([
  'mailinator.com', 'guerrillamail.com', 'tempmail.com',
  '10minutemail.com', 'throwaway.email', 'yopmail.com',
  'maildrop.cc', 'sharklasers.com', 'guerrillamailblock.com',
  'grr.la', 'guerrillamail.info', 'spam4.me', 'trashmail.com',
  'dispostable.com', 'mailnull.com', 'spamgourmet.com',
  'trashmail.me', 'trashmail.at', 'trashmail.io',
  'fakeinbox.com', 'mailnesia.com', 'mailexpire.com',
  'temp-mail.org', 'tempinbox.com', 'tempr.email',
  'discard.email', 'spamevader.com', 'spamfree24.org',
  'spamgob.com', 'spam.la', 'getairmail.com',
  'mailcatch.com', 'spamherelots.com', 'tempail.com',
  'getnada.com', 'mailtemp.org', 'throwam.com',
  'filzmail.com', 'wegwerpemail.de', 'mailsiphon.com',
  'spamwc.de', 'spamwc.net', 'classiemail.com',
  'mintemail.com', 'deadaddress.com', 'jetable.fr.nf',
  'nomail.xl.cx', 'obobbo.com', 'discardmail.com',
  'discardmail.de', 'spamspot.com', 'spamthisplease.com',
  'bspamfree.org', 'spamcannibal.org', 'spamobox.com',
  'spamoff.de', 'spam.ac', 'trashmail.net',
  'trashmail.org', 'trashmailer.com', 'inoutmail.eu',
]);

/** Returns true if the email domain is on the disposable blocklist. */
export function isDisposableEmail(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase()?.trim();
  if (!domain) return false;
  return DISPOSABLE_DOMAINS.has(domain);
}
